import React, { useState } from 'react';
import { SearchIcon, MapPinIcon, TagIcon } from 'lucide-react';
export function DiscoveryScreen() {
  const [searchQuery, setSearchQuery] = useState('');
  // Mock data for people nearby
  const peopleNearby = [{
    id: 'n1',
    name: 'Riley Johnson',
    role: 'CTO',
    company: 'DevStack',
    distance: '5m away',
    tags: ['Engineering', 'AI', 'Cloud Architecture'],
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?q=80&w=200&auto=format&fit=crop',
    fitScore: 82
  }, {
    id: 'n2',
    name: 'Sam Rodriguez',
    role: 'Investor',
    company: 'Venture Capital Partners',
    distance: '12m away',
    tags: ['SaaS', 'Funding', 'Startups'],
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?q=80&w=200&auto=format&fit=crop',
    fitScore: 65
  }];
  // Mock data for suggested connections
  const suggestedConnections = [{
    id: 's1',
    name: 'Jordan Lee',
    role: 'Marketing Director',
    company: 'GrowthLabs',
    tags: ['Digital Marketing', 'Growth Strategy'],
    image: 'https://images.unsplash.com/photo-1539571696357-5a69c17a67c6?q=80&w=200&auto=format&fit=crop',
    fitScore: 75
  }, {
    id: 's2',
    name: 'Casey Wong',
    role: 'UX Researcher',
    company: 'UserFirst',
    tags: ['User Testing', 'Product Design'],
    image: 'https://images.unsplash.com/photo-1517841905240-472988babdf9?q=80&w=200&auto=format&fit=crop',
    fitScore: 70
  }];
  return <div className="flex flex-col flex-1" data-id="element-58">
      <header className="p-4 border-b" data-id="element-59">
        <h1 className="text-xl font-bold text-gray-800 mb-3" data-id="element-60">Discovery</h1>
        <div className="relative" data-id="element-61">
          <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-62" />
          <input type="text" placeholder="Search by name, role, or interest" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg" data-id="element-63" />
        </div>
      </header>
      <div className="flex-1 p-4 overflow-y-auto" data-id="element-64">
        <div className="mb-6" data-id="element-65">
          <div className="flex items-center gap-2 mb-3" data-id="element-66">
            <MapPinIcon size={18} className="text-indigo-600" data-id="element-67" />
            <h2 className="text-lg font-semibold text-gray-800" data-id="element-68">
              People Nearby
            </h2>
          </div>
          <div className="space-y-3" data-id="element-69">
            {peopleNearby.map(person => <div key={person.id} className="bg-white rounded-lg shadow-sm p-4 border border-gray-100" data-id="element-70">
                <div className="flex items-center gap-3" data-id="element-71">
                  <img src={person.image} alt={person.name} className="w-12 h-12 rounded-full object-cover" data-id="element-72" />
                  <div className="flex-1" data-id="element-73">
                    <div className="flex items-center justify-between" data-id="element-74">
                      <h3 className="font-medium" data-id="element-75">{person.name}</h3>
                      <div className="bg-indigo-600 text-white text-xs px-2 py-1 rounded-full" data-id="element-76">
                        {person.fitScore}%
                      </div>
                    </div>
                    <p className="text-sm text-gray-500" data-id="element-77">
                      {person.role} at {person.company}
                    </p>
                    <div className="flex items-center text-xs text-indigo-600 mt-1" data-id="element-78">
                      <MapPinIcon size={12} className="mr-1" data-id="element-79" />
                      {person.distance}
                    </div>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1 mt-2" data-id="element-80">
                  {person.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full" data-id="element-81">
                      {tag}
                    </span>)}
                </div>
              </div>)}
          </div>
        </div>
        <div data-id="element-82">
          <div className="flex items-center gap-2 mb-3" data-id="element-83">
            <TagIcon size={18} className="text-indigo-600" data-id="element-84" />
            <h2 className="text-lg font-semibold text-gray-800" data-id="element-85">
              Suggested Connections
            </h2>
          </div>
          <div className="space-y-3" data-id="element-86">
            {suggestedConnections.map(person => <div key={person.id} className="bg-white rounded-lg shadow-sm p-4 border border-gray-100" data-id="element-87">
                <div className="flex items-center gap-3" data-id="element-88">
                  <img src={person.image} alt={person.name} className="w-12 h-12 rounded-full object-cover" data-id="element-89" />
                  <div className="flex-1" data-id="element-90">
                    <div className="flex items-center justify-between" data-id="element-91">
                      <h3 className="font-medium" data-id="element-92">{person.name}</h3>
                      <div className="bg-indigo-600 text-white text-xs px-2 py-1 rounded-full" data-id="element-93">
                        {person.fitScore}%
                      </div>
                    </div>
                    <p className="text-sm text-gray-500" data-id="element-94">
                      {person.role} at {person.company}
                    </p>
                  </div>
                </div>
                <div className="flex flex-wrap gap-1 mt-2" data-id="element-95">
                  {person.tags.map((tag, index) => <span key={index} className="bg-gray-100 text-gray-700 text-xs px-2 py-0.5 rounded-full" data-id="element-96">
                      {tag}
                    </span>)}
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
}